// extracted by mini-css-extract-plugin
export default {"modal":"ModalNetworkError_modal_kw7ZW","title":"ModalNetworkError_title_VmLjO","text":"ModalNetworkError_text_qDGHf"};